<template>
  <section class="about">
    <div class="about-hero">
      <img src="/grandma-swapp.webp" alt="Shirley Ann Swapp" class="about-photo">
      <div>
        <h2>About Grandma Swapp</h2>
        <p class="life-dates">June 28, 1929 - January 26, 2020</p>
      </div>
    </div>
    <p>
      Shirley Ann Dodds Swapp (1929-2020) was born in Panguitch, Utah and later
      lived in Cedar City. She passed away on January 26, 2020 in Layton, Utah,
      surrounded by family. She married Mont C. Swapp in 1952, and they were later
      sealed in the St. George Temple in 1994.
    </p>
    <p>
      Shirley loved flowers, hummingbirds, quilting, cooking for loved ones, and
      reading. She was known for her kindness and compassion, her deep faith, and
      her devotion to family. She is survived by seven children, many
      grandchildren and great-grandchildren, and a wide circle of friends and
      loved ones.
    </p>
    <p class="source">
      Source:
      <a
        href="https://www.maglebymortuary.com/obituaries/shirley-swapp"
        target="_blank"
        rel="noreferrer"
      >
        Magleby Mortuary obituary for Shirley Ann Swapp
      </a>
    </p>
  </section>
</template>

<script>
export default {
  name: 'AboutView'
}
</script>

<style>
.about {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 28px;
  line-height: 1.7;
  font-size: 1.05rem;
}

.about-hero {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 24px;
  align-items: center;
  margin-bottom: 20px;
}

.about-photo {
  width: min(220px, 45vw);
  border-radius: 14px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
}

.about h2 {
  margin-top: 0;
  font-family: 'Dancing Script', 'Crimson Pro', 'Garamond', 'Georgia', serif;
  font-size: 2rem;
}

.life-dates {
  margin: 6px 0 0;
  color: var(--muted-text);
}

.about p {
  color: var(--text);
}

.source {
  margin-top: 20px;
  font-size: 0.95rem;
  color: var(--muted-text);
}

.source a {
  color: var(--accent);
}

@media (max-width: 720px) {
  .about-hero {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .about-photo {
    margin: 0 auto;
  }
}
</style>
